import { useState } from 'react';
import { PageHeader } from '@/components/ui';
import { Tabs, TabList, TabTrigger, TabContent } from '@/components/ui/Tabs';
import { PageContainer } from '@/components/layout';
import { ApplicationLogsTab } from '@/components/admin-logs/ApplicationLogsTab';
import { AuditLogTab } from '@/components/admin-logs/AuditLogTab';
import { AiApiLogTab } from '@/components/admin-logs/AiApiLogTab';

type LogsTab = 'application' | 'audit' | 'ai-api';

export function AdminLogsPage() {
  const [activeTab, setActiveTab] = useState<LogsTab>('application');

  return (
    <PageContainer variant="wide" className="space-y-6">
      <PageHeader
        title="Logs"
        subtitle="Application logs, audit events, and AI API usage in one place."
      />

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabList>
          <TabTrigger value="application">Application Logs</TabTrigger>
          <TabTrigger value="audit">Audit Log</TabTrigger>
          <TabTrigger value="ai-api">AI API Log</TabTrigger>
        </TabList>

        <TabContent value="application">
          <ApplicationLogsTab />
        </TabContent>

        <TabContent value="audit">
          <AuditLogTab />
        </TabContent>

        <TabContent value="ai-api">
          <AiApiLogTab />
        </TabContent>
      </Tabs>
    </PageContainer>
  );
}
